import { inRange } from "./in-range";

export interface Accessors<T> {
  /** Returns the start date/time of the event */
  start: (evt: T) => Date;
  /** Returns the end date/time of the event */
  end: (evt: T) => Date;
}

/**
 * Filters a list of events to those that fall within the given week range.
 *
 * @param evts - Array of event objects.
 * @param start - The start Date of the week.
 * @param end - The end Date of the week.
 * @param accessors - Functions to extract start/end dates from each event.
 * @returns A filtered array of events within [start, end].
 */
export function eventsForWeek<T>(
  evts: T[],
  start: Date,
  end: Date,
  accessors: Accessors<T>,
): T[] {
  return evts.filter((e) => inRange(e, start, end, accessors));
}

export default eventsForWeek;
